<script setup>
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { orderConfirm } from '@/api/PaymentApi';

definePage({ meta: { layout: 'purchase' } });

const router = useRouter();
const route = useRoute();
const orderId = ref('');
const paymentKey = ref('');
const amount = ref('');
// 이동할 페이지 정보
const next = ref('');

//TODO 이용권 결제
const order = async () => {
  try {
    const paramSubscr = {
      orderId: orderId.value,
      paymentKey: paymentKey.value,
      amount: amount.value,
    };
    const subscrData = await orderConfirm(paramSubscr);
    router.push({
      path: '/purchase/nmspFinishPointEnd',
      query: {
        next: next.value,
      },
    });
  } catch (error) {
    console.log(error);
    const errorMessage = error.response?.data?.detail || '결제 처리 중 오류가 발생했습니다.';
    router.push(`/purchase/nmspFinishPointFail?message=${encodeURIComponent(errorMessage)}`);
  }
};

//TODO 컴포넌트가 마운트될 때 이용권 결제 확인 호출
onMounted(() => {
  orderId.value = route.query.orderId;
  paymentKey.value = route.query.paymentKey;
  amount.value = route.query.amount;
  next.value = route.query?.next;
  order();
});
</script>
